import React from 'react';
import { cn } from '../../lib/classNames';

export const Card = ({ className, ...props }) => (
  <div className={cn('rounded-lg border border-border bg-card text-card-foreground shadow-soft', className)} {...props} />
);

export const CardHeader = ({ className, ...props }) => (
  <div className={cn('border-b border-border px-5 py-4', className)} {...props} />
);

export const CardTitle = ({ className, children, ...props }) => (
  <div
    className={cn('mb-0 text-[1rem] font-semibold leading-6 text-foreground', className)}
    role="heading"
    aria-level={3}
    {...props}
  >
    {children}
  </div>
);

export const CardDescription = ({ className, ...props }) => (
  <p className={cn('mb-0 mt-1 text-sm text-muted-foreground', className)} {...props} />
);

export const CardContent = ({ className, ...props }) => (
  <div className={cn('p-5', className)} {...props} />
);
